import axios from 'axios';

export default {
  logIn: (user) => axios.post('/login', user),
  logOut: (user) => axios.post('/logoout', user),
  relogIn: (userData) => axios.post('/Token', userData),
  getUsuarios: () => axios.get('/Usuarios'),
  insertUsuarios: (user) => axios.post('/Usuarios', user),
  deleteUsuarios: (user) => axios.delete(`/Usuarios/${user}`),
  updateUsuarios: (user) => axios.put('/Usuarios', user),
  cambiarDatosUsuario: (userDatos) => axios.put('/actualiza_email_pass', userDatos),
  getFraccionasA: (fa) => axios.get(`/Fraciones_ancelarias?pag=${fa.pag}&regPag=${fa.regPag}`),
  getFraccionasAWithSearch: (fa) => axios.get(`/Fraciones_ancelarias?pag=${fa.pag}&regPag=${fa.regPag}&filtro=${fa.textoBusqueda}`),
  insertFraccionasA: (fa) => axios.post('Fraciones_ancelarias', fa),
  deleteFraccionasA: (fa) => axios.delete(`/Fraciones_ancelarias/${fa}`),
  editFraccionasA: (fa) => axios.put('Fraciones_ancelarias', fa),
  getRoles: () => axios.get('/Roles'),
  getSucursales: () => axios.get('/Sucursales'),
  insertSucursales: (suc) => axios.post('/Sucursales', suc),
  //tarifas, antes eran descuentos
  getTarifas: () => axios.get('/Tarifas'),
  editTarifas: (tar) => axios.put('/Tarifas', tar),
  insertTarifas: (tar) => axios.post('/Tarifas', tar),
  deleteTarifas: (tar) => axios.delete(`/Tarifas/${tar}`),

  getCuentas: () => axios.get('/Cuentas'),
  insertCuentas: (acc) => axios.post('/Cuentas', acc),
  deleteSucursales: (suc) => axios.delete(`/Sucursales/${suc}`),
  //sepomex
  getDatosConCodigoPostal: (cod) => axios.get(`/SepomexCodigoPostal/${cod}`),
  getListaPaises: () => axios.get('/SepomexPaises'),

  deleteCuentas: (acc) => axios.delete(`/Cuentas/${acc}`),
  editSucursales: (suc) => axios.put('/Sucursales', suc),

  editCuentas: (acc) => axios.put('/Cuentas', acc),
  // remitentes y destinatarios administrador
  getDestinatarios: (dest) => axios.get(`/Destinatarios?pag=${dest.pag}&regPag=${dest.regPag}${dest.suc}${dest.filtroBusquedaFinal}`),
  getRemitentes: (remi) => axios.get(`/Remitentes?pag=${remi.pag}&regPag=${remi.regPag}${remi.suc}${remi.filtroBusquedaFinal}`),

  insertRemitentes: (remi) => axios.post('/Remitentes', remi),
  insertDestinatarios: (dest) => axios.post('/Destinatarios', dest),
  deleteDestinatarios: (dest) => axios.delete(`/Destinatarios/${dest}`),
  deleteRemitentes: (remi) => axios.delete(`/Remitentes/${remi}`),
  editRemitentes: (remi) => axios.put('/Remitentes', remi),
  updateTarifasRemitentes: (remi) => axios.put('/ActualizaTarifa', remi),
  editDestinatarios: (dest) => axios.put('/Destinatarios', dest),
  getDestinatarioMostrador: (destm) => axios.get(`/ObtenerDestinatario?filtro=${destm}`),
  getRemitenteMostrador: (remm) => axios.get(`/ObtenerRemitente?filtro=${remm}`),
  getContrato: () => axios.get('/Contrato'),
  editContrato: (cont) => axios.put('/Contrato', cont),
  insertEnvios: (env) => axios.post('/Envios', env),

  updatePassworPaso1: (pass) => axios.put('/restablecer_pass', pass),
  updatePasswordPaso2: (pass) => axios.put('/actualiza_pass', pass),

  getEnvios: (env) => axios.get(`/Envios?pag=${env.pag}&regPag=${env.regPag}${env.referencia}${env.remitente}${env.destinatario}&fecha_inicio=${env.fecha_inicio}&fecha_fin=${env.fecha_fin}${env.tipoServicio}${env.detalleEnvio}${env.estado}${env.usuarioEnvio}${env.cuenta}${env.guia_fedex}${env.sucursal}`),

  getEnviosParaExcel: (env) => axios.get(`/Envios?pag=1&regPag=1000&fecha_inicio=${env.fecha_inicio}&fecha_fin=${env.fecha_fin}`),

  insertAbono: (abono) => axios.post('/AbonarEnvio', abono),

  deleteEnvios: (env) => axios.delete(`/CancelarEnvio/${env}`),

  getEnviosMostrador: (env) => axios.get(`/ObtenerEnvio?filtro=${env}`),
  getVecona: (vec) => axios.get(`/Vecona?pag=${vec.pag}&regPag=${vec.regPag}${vec.referencia}${vec.remitente}${vec.destinatario}${vec.tipoServicio}${vec.detalleEnvio}${vec.sucursal}${vec.guiaFedex}${vec.fechaInicio}${vec.fechaFin}${vec.estado}`),
  getVecoin: (vec) => axios.get(`/Vecoin?pag=${vec.pag}&regPag=${vec.regPag}${vec.referencia}${vec.remitente}${vec.destinatario}${vec.tipoServicio}${vec.detalleEnvio}${vec.sucursal}${vec.guiaFedex}${vec.fechaInicio}${vec.fechaFin}${vec.estado}`),
  insertDireccionDest: (dest) => axios.post('/InsertaDireccionD', dest),
  insertDireccionRem: (rem) => axios.post('/InsertaDireccionR', rem),
  cambioDireccion: (dirEnv) => axios.post('/CambiaDireccionEnvio', dirEnv),

  getUltimaRef: () => axios.get('/UltimaRef'),

  getRemitentesParaAbonos: (abon) => axios.get(`/ObtenerRemAbono?filtro=${abon}`),
  getDeudaUnRemitente: (abonRem) => axios.get(`/DeudaCliente?Remitente=${abonRem}`),
  insertAbonoMultiple: (abono) => axios.post('/Abonar', abono),

  getSucursalEnLaQueEstoy: (sucID) => axios.get(`/ObtenerSucursal/${sucID}`),
  getResumenCobranza: (resCob) => axios.get(`/ResumenCobranza?pag=${resCob.pag}&regPag=${resCob.regPag}${resCob.alias}${resCob.nombre}${resCob.telefono}${resCob.sucursal}`),
  getCortesDeCaja: (cut) => axios.get(`/CortesCaja?pag=${cut.pag}&regPag=${cut.regPag}${cut.usuario}${cut.sucursal}${cut.fechaInicio}${cut.fechaFin}`),
  getCortesDeCajaAgrupado: (cut) => axios.get(`/CortesCajaAgrupado?pag=${cut.pag}&regPag=${cut.regPag}${cut.sucursal}${cut.fechaInicio}${cut.fechaFin}`),
  getEfectivoCaja: (suc) => axios.get(`/EfectivoCaja/${suc}`),
  getTotalesCobranza: (resCob) => axios.get(`/TotalesCobranza/?${resCob.alias}${resCob.nombre}${resCob.telefono}${resCob.sucursal}`),
  hacerCorteDeCaja: (cut) => axios.put('/CorteCaja', cut),

  //edicion de envios
  getGuiasDeEnvio: (envID) => axios.get(`/obtener_guias_envio/${envID}`),
  updateGuiasDeEnvio: (objGuias) => axios.put('/actualizar_guias', objGuias),

  // conciliacion
  updateConciliacion: (objConc) => axios.put('/info_fedex', objConc),

  //totales vecona

  getTotalesVecona: (vec) => axios.get(`/totales_vecona?${vec.referencia}${vec.remitente}${vec.destinatario}${vec.tipoServicio}${vec.detalleEnvio}${vec.sucursal}${vec.guiaFedex}${vec.fechaInicio}${vec.fechaFin}${vec.estado}`),
  getTotalesVecoin: (vec) => axios.get(`/totales_vecoin?${vec.referencia}${vec.remitente}${vec.destinatario}${vec.tipoServicio}${vec.detalleEnvio}${vec.sucursal}${vec.guiaFedex}${vec.fechaInicio}${vec.fechaFin}${vec.estado}`),


  getInfoEnvioRemitente: (id) => axios.get(`/IdRemitente/${id}`),
};
